export const TiposExcepcion = [
    {
        codigoExcepcion: 0,
        textoExcepcion: "TIEMPO"
    }, {
        codigoExcepcion: 1,
        textoExcepcion: "MORA"
    }];



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/modelo/TiposExcepcion.ts